export default __webpack_public_path__ + "static/media/Temperature.3010cf41.svg";